import React from "react";
import "./Policy.css";

const TermsConditions = () => {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <h1>Terms & Conditions</h1>
        <p>
          Please read these Terms & Conditions carefully before using the
          services provided by E-Advisors Solution.
        </p>
      </div>

      <div className="policy-content">

        {/* ABOUT US */}
        <div className="policy-section">
          <h2>📌 About Us</h2>

          <p>
            Welcome to E-Advisors Solution.
          </p>

          <p>
            E-Advisors Solution is an online business registration portal for
            startups & MSMEs in India. E-Advisors Solution renders a wide range
            of services in the area of company incorporation, GST registration,
            FSSAI registration, obtaining Import Export Code (IEC), preparing
            business plans, helping in protecting brand/intellectual property
            including trademark, copyright, and patent, securing ISO
            certification, and providing legal & financial consultancy for MSME
            businesses.
          </p>

          <p>
            E-Advisors Solution Website and Mobile Application are owned and
            maintained by E-Advisors Solution.
          </p>
        </div>

        {/* AGREEMENT */}
        <div className="policy-section">
          <h2>📄 Agreement</h2>

          <p>
            Please read the terms and conditions set out below carefully before
            ordering any product or service from our website, mobile
            application, or any other mode.
          </p>

          <p>
            By using or ordering any product or service from our website,
            mobile application, or any other mode including by any computer
            equipment, phone/mobile, or electronic device, you agree to be
            bound by these Terms and Conditions.
          </p>
        </div>

        {/* GENERAL */}
        <div className="policy-section">
          <h2>⚖️ General</h2>

          <div className="policy-card">
            <ul>
              <li>
                In terms of the Information Technology Act, 2000, this document
                is an electronic record and does not require any physical or
                digital signatures.
              </li>

              <li>
                The domain name www.e-advisorssolution.com is owned and
                maintained by E-Advisors Solution.
              </li>
            </ul>
          </div>
        </div>

        {/* USER OBLIGATIONS */}
        <div className="policy-section">
          <h2>👤 User Obligations</h2>

          <div className="policy-card">
            <ul>
              <li>
                By visiting our website and accessing our services, products,
                tools, and resources, you agree to comply with these Terms &
                Conditions and our Privacy Policy.
              </li>

              <li>
                By signing up or signing in to the mobile application, you
                agree to additional terms of use applicable to our products and
                services.
              </li>

              <li>
                E-Advisors Solution does not intend to solicit services that
                are legally required to be performed by practicing Chartered
                Accountants (CAs), Company Secretaries (CSs), Lawyers, or other
                authorized professionals.
              </li>

              <li>
                You agree that we may use our company email ID or mobile number
                to receive OTPs and verification tokens for processing your
                applications efficiently.
              </li>

              <li>
                We reserve the right to modify these Terms & Conditions at any
                time without prior notice.
              </li>

              <li>
                Information provided by you including identification proof,
                address proof, email address, phone number, and other details
                must always be accurate and up to date.
              </li>

              <li>
                Accessing our resources through automated, unethical, or
                unconventional means is strictly prohibited.
              </li>

              <li>
                Activities that disrupt or interfere with our servers,
                networks, or services are prohibited.
              </li>

              <li>
                By using this website, you confirm that you are legally eligible
                to access and use the services.
              </li>

              <li>
                You may print individual pages for personal and non-commercial
                use only.
              </li>

              <li>
                You may not copy, modify, reproduce, publish, distribute,
                license, or sell any material from this website without prior
                written permission.
              </li>

              <li>
                You agree not to use this website for unlawful, immoral, or
                prohibited activities.
              </li>

              <li>
                Content provided on the website is for informational purposes
                only and does not constitute legal, taxation, investment, or
                financial advice.
              </li>

              <li>
                All promotional offers and discounts remain valid only for the
                specified duration or a maximum of 7 days if no validity period
                is mentioned.
              </li>

              <li>
                E-Advisors Solution disclaims responsibility for any damages
                caused by downloading information or data from the website.
              </li>

              <li>
                In case of any deficiency in services, our liability shall be
                limited strictly to the amount paid by the customer.
              </li>

              <li>
                We reserve the right to modify dashboard passwords when
                required to ensure service quality and security.
              </li>

              <li>
                You are solely responsible for any losses or damages arising
                from unauthorized activities performed using your account.
              </li>

              <li>
                E-Advisors Solution and its employees shall not be liable for
                losses caused by affiliate vendors, agents, or third-party
                service providers.
              </li>

              <li>
                You shall not upload, share, publish, or distribute illegal,
                threatening, defamatory, abusive, fraudulent, offensive,
                explicit, or otherwise objectionable content.
              </li>

              <li>
                We reserve the right to remove content that violates these
                Terms & Conditions or infringes any third-party rights.
              </li>
            </ul>
          </div>
        </div>

        {/* INDEMNIFICATION */}
        <div className="policy-section">
          <h2>🛡️ Indemnification & Limitation of Liability</h2>

          <p>
            You agree to indemnify, defend, and hold harmless E-Advisors
            Solution, its owners, affiliates, vendors, agents, and employees
            from any losses, liabilities, claims, damages, demands, costs, and
            expenses arising from your use of the website, violation of these
            Terms & Conditions, or infringement of any third-party rights.
          </p>
        </div>

        {/* GUARANTEE */}
        <div className="policy-section">
          <h2>📋 Guarantee</h2>

          <p>
            Unless otherwise expressly stated,
            www.e-advisorssolution.com disclaims all warranties and conditions,
            whether express or implied, including warranties of
            merchantability, fitness for a particular purpose, and
            non-infringement.
          </p>
        </div>

        {/* TERMINATION */}
        <div className="policy-section">
          <h2>⛔ Termination of Use</h2>

          <p>
            We reserve the right, at our sole discretion, to suspend or
            terminate your access to all or part of our website and services,
            with or without notice, if you violate these Terms & Conditions.
          </p>
        </div>

        {/* DATA PROVIDED */}
        <div className="policy-section">
          <h2>📚 Data Provided By Us</h2>

          <div className="policy-card">
            <ul>
              <li>
                Articles, blogs, comments, and content published by our team
                are intellectual property of E-Advisors Solution.
              </li>

              <li>
                Reproduction, publication, editing, or distribution of such
                content without permission is prohibited.
              </li>

              <li>
                While we strive to ensure accuracy, system errors may occur and
                we are not responsible for losses arising from inaccuracies.
              </li>

              <li>
                We shall not be liable for losses resulting from negligence,
                contract breaches, intellectual property issues, or legal
                violations.
              </li>

              <li>
                External links may be provided for convenience, but we do not
                endorse or assume responsibility for third-party websites.
              </li>
            </ul>
          </div>
        </div>

        {/* THIRD PARTY */}
        <div className="policy-section">
          <h2>🌐 Third-Party Information</h2>

          <p>
            Text, graphics, trademarks, logos, photographs, sounds, music,
            artwork, and user-generated content not owned by E-Advisors
            Solution remain the responsibility of their respective owners.
          </p>

          <p>
            Any content submitted by users may become the property of
            E-Advisors Solution, and users grant us worldwide, perpetual, and
            transferable rights to use such content for lawful promotional,
            advertising, or business purposes.
          </p>
        </div>

        {/* DISPUTE */}
        <div className="policy-section">
          <h2>⚖️ Dispute Resolution</h2>

          <p>
            This Agreement, its interpretation, enforcement, and any disputes
            arising from it shall be governed by the laws of India and subject
            to the exclusive jurisdiction of courts located in Delhi, India.
          </p>
        </div>

        {/* CONTACT */}
        <div className="website-card">
          <h3>📧 Contact Us</h3>

          <p>
            If you have any questions regarding these Terms & Conditions or our
            services, please contact us:
          </p>

          <a href="mailto:info@e-advisorssolution.com">
            info@e-advisorssolution.com
          </a>
        </div>

      </div>
    </div>
  );
};

export default TermsConditions;